<template>
  <div>
    <div v-if="!groupOpen"><v-icon>expand_more</v-icon></div>
    <div v-if="groupOpen"><v-icon>expand_less</v-icon></div>
  </div>
</template>

<script>
export default {
  name: 'OpenCloseButton',
  props: {
    groupOpen: Boolean,
  },
}
</script>

<style scoped></style>
